(() => {
  // Keep anchors accurate when merchants remove/reorder sections in the editor.
  const syncTargets = () => {
    document.querySelectorAll('.wholesale-product-page [data-pdp-target]').forEach((link) => {
      const target = document.getElementById(link.hash.slice(1));
      link.hidden = !target;
    });
    document.querySelectorAll('pdp-section-nav').forEach((nav) => {
      nav.hidden = !Array.from(nav.querySelectorAll('a')).some((link) => !link.hidden);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncTargets, { once: true });
  else syncTargets();
  document.addEventListener('shopify:section:load', syncTargets);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncTargets));

  if (!customElements.get('pdp-section-nav')) {
    customElements.define('pdp-section-nav', class extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const link = event.target.closest('a');
          if (!link || link.hidden) return;
          this.querySelectorAll('a').forEach((item) => item.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'location');
        };
        this.addEventListener('click', this.onClick);
      }
      disconnectedCallback() { this.removeEventListener('click', this.onClick); }
    });
  }

  if (!customElements.get('pdp-enquiry-form')) {
    customElements.define('pdp-enquiry-form', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
        // Read from the current form on submit as well: unavailable combinations do not publish variantChange.
        this.syncVariant = () => {
          const picker = this.productInfo?.querySelector('[data-selected-variant]');
          let variant = null;
          try { variant = picker ? JSON.parse(picker.textContent) : null; } catch { /* Retain no stale selection. */ }
          const idInput = this.productInfo?.querySelector('product-form input[name="id"]');
          const id = idInput?.value || '';
          if (!id) variant = null;
          const field = (selector, value) => { const node = this.querySelector(selector); if (node) node.value = value; };
          field('[data-pdp-product-url]', `${this.dataset.productUrl}${id ? `?variant=${encodeURIComponent(id)}` : ''}`);
          if (picker) {
            field('[data-pdp-variant]', variant?.title || '');
            field('[data-pdp-sku]', variant?.sku || '');
          }
        };
        this.addEventListener('submit', this.syncVariant);
        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId === this.productInfo?.dataset.section) this.syncVariant();
          });
        }
      }
      disconnectedCallback() {
        this.unsubscribe?.();
        this.removeEventListener('submit', this.syncVariant);
      }
    });
  }
})();
